<template lang="html">

  <Modal 
    @close-x="$emit('CloseCompletedModal')"
    :footer="false"
    :closeBtn="closeBtn"
    class="pe_completed-modal"

  >
    <template #title>
      <slot name="title">Congratulations!</slot>
    </template>
    
      <template #body>
        <slot name="body">
          <div class="pe_flex-column pe_center">
            <Trophy />
            <Stopwatch />
            <p v-if="game.completed">Your best time: {{ myBestTime(game.puzzleBestTime, totalTime, hintsUsed) }}</p>
            <p class="pe_hint-used" v-if="gameMode !== 'challenge' && allowHints">
              Hints used: {{ game.hintsUsed }}
            </p>

            <div v-if="showRank" class="pe_rank">
              <div>Current rank: <strong v-if="rank && total">{{ rank }} of {{ total }}</strong> <Spinner type="circle" v-else /></div>
              <div>
                Best time: {{ secondsToHms(bestPuzzleTime) }}
              </div>
              <!--<div>Rank (all players): </div>
              <div>
                <strong v-if="rank && total">{{ rankAll }} of {{ totalAll }}</strong> 
                <Spinner type="circle" v-else />
              </div>-->
            </div>

            <!--<a 
              @click.prevent="resetPuzzle()"
              class="pe_btn pe_grey"
            >
              Play again
            </a> -->

            <router-link 
              to="/archive"
              class="pe_btn pe_grey"
            >
              Play previous puzzles
            </router-link>
              
            <router-link 
              to="/"
              class="pe_btn pe_grey"
            > 
              Main menu
            </router-link>

          </div>
        </slot>
      </template>
  </Modal>

</template>

<script lang="js">

  import { mapState, mapGetters, mapActions } from 'vuex'
  import Modal from '@puzzleapps/shared/src/components/ui/Modal'

  import Stopwatch from '@puzzleapps/shared/src/components/ui/StopWatch'
  import Trophy from '@puzzleapps/shared/src/components/ui/icons/Trophy'
  import Play from '@puzzleapps/shared/src/components/ui/icons/Play'
  import Spinner from '@puzzleapps/shared/src/components/ui/Spinner'

import api from '@puzzleapps/shared/src/utils/api'

  export default  {
    name: 'difficulty-select',
    props: ['date', 'closeBtn'], // date, format YYYY-MM-DD
    
    components: {
      Modal,
      Stopwatch,
      Trophy,
      Spinner,
    },

    data() {
      return {
        rank: null,
        rankAll: null,
        total: null,
        totalAll: null,
        showRank: false,
        manuallyClosedModal : false,
        bestPuzzleTime: null,
        bestClientPuzzleTime: null,
        hideCompModal: false,
      }
    },

    mounted() {
      if (this.game.playId && this.gameMode === 'challenge' && this.game.hintsUsed < 1) {
        api.rank(this.game.playId)
        .then(rank => {
          if (rank.noRank) {
            this.showRank = false
          }
          else {
            /*this.showRank = true
            this.rank = rank.rank
            this.rankAll = rank.rankAll
            this.total = rank.total
            this.totalAll = rank.totalAll
            this.bestPuzzleTime = rank.bestPuzzleAllTime
            this.bestClientPuzzleTime = rank.bestPuzzleClientTime*/
          }
        })
      }
      else
      {
        this.manuallyClosedModal = false
      }
    },

    // destroyed() {
      
    // },

    methods: {
      ...mapActions({
        resetPuzzle: 'game/resetPuzzle',
      }), 
      
      onManuallyClosedModal()
      {
        this.manuallyClosedModal = true
        //this.game.completed = false
      },


      secondsToHms(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secondsRemainder = seconds % 60;
        const hoursString = hours.toString().padStart(2, '0');
        const minutesString = minutes.toString().padStart(2, '0');
        const secondsString = secondsRemainder.toString().padStart(2, '0');

        if(hours > 0)
          return `${hoursString}:${minutesString}:${secondsString}`;
        else
          return `${minutesString}:${secondsString}`;

      },

      myBestTime(bTime, tTime, hintCount)
      {
        let penaltyTime = tTime + (10000 * hintCount)
        
        if(bTime > 0)
        {
          if(penaltyTime < bTime)
          {
            return this.secondsToHms(Math.floor(penaltyTime/1000))
          }
          else
          {
            return this.secondsToHms(Math.floor(bTime/1000))
          }
        }
        else
        {
          return this.secondsToHms(Math.floor(penaltyTime/1000))
          //return "0"
        }
          
      }


    },

    computed: {
      ...mapState({
        game: state => state.game,
        gameMode: state => state.userSettings.gameMode,
        allowHints: state => state.userSettings.allowHints,
        triviaData: state => state.grid.triviaData,
        completed: state => state.game.completed,
        bestTime: state => state.game.puzzleBestTime,
        totalTime: state => state.game.totalTime,
        hintsUsed: state => state.game.hintsUsed,
      }),

      ...mapGetters({
        formattedTotalTime: 'game/formattedTotalTime',
        adjustedTotalTime: 'game/formattedAdjustedTime'
      }),

    }
  }

</script>

<style scoped lang="scss">
@import '@puzzleapps/shared/src/style/completedModal';
</style>